import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, map, Observable } from 'rxjs';

export type Resource = { prefix: string; suffix: string };

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(private readonly http: HttpClient) {}

  getTranslation(lang: string): Observable<Record<string, unknown>> {
    const resources: Resource[] = [
      { prefix: '/assets/i18n/', suffix: '-shared.json' },
      { prefix: '/assets/i18n/', suffix: '.json' },
    ];
    return forkJoin(
      resources.map((resource) => {
        return this.http.get<Record<string, unknown>>(`${resource.prefix}${lang}${resource.suffix}`);
      })
    ).pipe(map((response: Record<string, unknown>[]) => response.reduce((arr, item) => ({ ...arr, ...item }))));
  }
}
